import { Matrix4, Vector3 } from 'three'

export default function getModelPositions(scene, canvasHeight) {
    const positions = []

    const scaleVector = new Vector3(6, 6, 6)
    const translationVector = new Vector3(0, -(canvasHeight / 4), 0)
    scene.traverse(child => {
        if (child.isMesh && child.geometry.isBufferGeometry) {
            const positionAttribute = child.geometry.getAttribute('position')
            if (positionAttribute) {
                const vertices = positionAttribute.array
                const numVertices = vertices.length / 3
                const matrix = new Matrix4()
                child.updateMatrixWorld(true)
                matrix.copy(child.matrixWorld)

                for (let i = 0; i < numVertices; i++) {
                    const x = vertices[i * 3]
                    const y = vertices[i * 3 + 1]
                    const z = vertices[i * 3 + 2]

                    const vertex = new Vector3(x, y, z)
                    vertex.applyMatrix4(matrix)
                    vertex.multiply(scaleVector)
                    vertex.add(translationVector)

                    positions.push(vertex)
                }
            }
        }
    })

    return positions
}
